import { useEffect, useState } from "react";
import { Productbtn } from "../../../../../../shared/services/interface";

export const useCartCalculations = (
  selectedProductslist: Productbtn[],
  valueMap: { [id: string]: number },
  condition: number,   // discount
  deliveryFee: number  // delivery fee
) => {
  const [totalQuantity, setTotalQuantity] = useState<number>(0);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [dis_value, setDis_value] = useState<number>(0);   // ✅ after discount
  const [grandTotal, setGrandTotal] = useState<number>(0); // ✅ final

  useEffect(() => {
    let quantity = 0;
    let amount = 0;

    for (const product of selectedProductslist) {
      const key = `${product._id.$oid}-${product.Amount}`;
      const qty = valueMap[key] || 1;

      quantity += qty;
      amount += Number(product.Amount) * qty;
    }

    const discount = Number(condition) || 0;
    const delivery = Number(deliveryFee) || 0;

    const afterDiscount = Math.max(0, amount - discount);
    const finalTotal = afterDiscount + delivery;

    setTotalQuantity(quantity);
    setTotalAmount(amount);
    setDis_value(afterDiscount);   // ✅ ONLY THIS for discounted amount
    setGrandTotal(finalTotal);     // ✅ discount + delivery
  }, [selectedProductslist, valueMap, condition, deliveryFee]);

  return {
    totalQuantity,
    totalAmount,
    dis_value,
    grandTotal,
  };
};
